import { SupportedToken } from "../types/faucet";

export const SUPPORTED_TOKENS: Partial<SupportedToken>[] = [
  {
    id: 1,
    symbol: "ETH",
    name: "Ethereum",
    contractAddress: null,
    decimals: 18,
    isNative: true,
    standardAmount: "0.00100000",
    active: true,
  },
  {
    id: 6,
    symbol: "MOG",
    name: "Mog Coin",
    contractAddress: "0x99dbe4aea58e518c50a1c04ae9b48c9f6354612f",
    decimals: 18,
    isNative: false,
    standardAmount: "1000.00000000",
    active: true,
  },
  {
    id: 7,
    symbol: "PEPE",
    name: "Pepe",
    contractAddress: "0x6f6f570f45833e249e27022648a26f4076f48f78",
    decimals: 18,
    isNative: false,
    standardAmount: "1000000.00000000",
    active: true,
  },
  {
    id: 5,
    symbol: "RISE",
    name: "RISE",
    contractAddress: "0xd6e1afe5ca8d00a2efc01b89997abe2de47fdfaf",
    decimals: 18,
    isNative: false,
    standardAmount: "100.00000000",
    active: true,
  },
  {
    id: 2,
    symbol: "USDC",
    name: "USD Coin",
    contractAddress: "0x8a93d247134d91e0de6f96547cb0204e5be8e5d8",
    decimals: 6,
    isNative: false,
    standardAmount: "10.00000000",
    active: true,
  },
  {
    id: 3,
    symbol: "USDT",
    name: "Tether USD",
    contractAddress: "0x40918ba7f132e0acba2ce4de4c4baf9bd2d7d849",
    decimals: 8,
    isNative: false,
    standardAmount: "10.00000000",
    active: true,
  },
  {
    id: 4,
    symbol: "WBTC",
    name: "Wrapped Bitcoin",
    contractAddress: "0xf32d39ff9f6aa7a7a64d7a4f00a54826ef791a55",
    decimals: 18,
    isNative: false,
    standardAmount: "0.00050000",
    active: true,
  },
];
